const AssociatedExecutionStates = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};
export default AssociatedExecutionStates;